function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
import Button from 'react-bootstrap/Button';
export default function DestructiveButton({
  text,
  confirmation,
  doFetch,
  onClick,
  onInitialClick,
  onSuccess,
  variant,
  disabled,
  ...props
}) {
  let [clicked, setClicked] = React.useState(false);
  let [sending, setSending] = React.useState(false);
  let [error, setError] = React.useState('');
  variant = variant || 'danger';
  const onClickCallback = React.useCallback(e => {
    e.preventDefault();
    e.stopPropagation();
    if (!clicked) {
      setClicked(true);
      if (onInitialClick) {
        onInitialClick(e);
      }
    } else {
      setSending(true);
      if (doFetch) {
        doFetch().then(r => r.json()).then(r => {
          setSending(false);
          if (r.message) {
            setError(r.message);
            setClicked(false);
          } else {
            onSuccess(r);
          }
        }).catch(e => {
          setError(e.message);
          setClicked(false);
          setSending(false);
        });
      } else if (onClick) {
        onClick(e);
        setClicked(false);
        setSending(false);
      }
    }
  }, [clicked, onInitialClick, doFetch, onClick, setClicked, setSending, setError]);
  const onMouseOut = React.useCallback(e => {
    if (clicked) {
      setClicked(false);
    }
  }, [clicked, setClicked]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Button, _extends({}, props, {
    variant: clicked ? variant : `outline-${variant}`,
    disabled: disabled !== undefined ? disabled : sending,
    onClick: onClickCallback,
    onMouseOut: onMouseOut
  }), clicked ? confirmation : text), error && /*#__PURE__*/React.createElement("div", {
    className: "error"
  }, error));
}